module.exports = __webpack_public_path__ + "img/pro1.0fe3d27a.png";